module.exports = __webpack_public_path__ + "img/slider-count.94ecf8ba.svg";